import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden; /* Prevents horizontal scroll from small overflows */
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    background: ${({ theme }) => theme.body};
    background-image: ${({ theme }) => theme.bodyGradient};
    background-attachment: fixed;
    background-size: cover;
    color: ${({ theme }) => theme.text};
    transition: all 0.25s linear;
  }

  * {
    box-sizing: border-box;
  }
`;